import { render, staticRenderFns } from "./LoginAdmin.vue?vue&type=template&id=0704bd06&scoped=true"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704bd06",
  null
  
)

export default component.exports